<template>
  <v-footer color="background" absolute class="footer">
    <v-spacer />
    <div>&copy; PCM Soluções Ltda. {{ new Date().getFullYear() }} - {{ version }} | Todos os direitos reservados.</div>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    version: process.env.VUE_APP_VERSION,
  }),
}
</script>

<style scoped>
.footer {
  z-index: 1;
}
</style>
